import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalDialogType, UserAndSellerShowMode } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosUserAndSellerListModalService } from 'src/app/@core/services/pos-user-and-seller-list-modal.service';
import { SendTokenRequest } from 'src/app/models/request/send-token-request';
import { User } from 'src/app/models/user';
import { TokenAuthorizationService } from 'src/app/services/token-authorization.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-auth-token-generation',
  templateUrl: './auth-token-generation.component.html',
  styleUrls: ['./auth-token-generation.component.sass']
})
export class AuthTokenGenerationComponent implements OnInit {


  processes: Array<{ key: string, value: string }> = [];
  tokenForm: FormGroup = new FormGroup({
    userRequester: new FormControl(undefined, Validators.required),
    userRequesterDescription: new FormControl(undefined),
    email: new FormControl(undefined, [Validators.required, Validators.email]),
    observations: new FormControl(undefined, Validators.required),
    process: new FormControl(undefined, Validators.required)
  });

  constructor(private readonly sellerListModalService: PosUserAndSellerListModalService, private readonly tokenAuthService: TokenAuthorizationService, private readonly confirmService: PosConfirmationService) {
    this.processes.push({ key: "CREDITORDER", value: "Facturación al Crédito" }, { key: "CASHLOAN", value: "Préstamo en Efectivo" });
  }

  ngOnInit(): void {
  }

  async showSellerList() {
    const user = await this.sellerListModalService.show(UserAndSellerShowMode.USERS, false) as User;
    this.tokenForm.get("userRequester")?.setValue(user.username);
    this.tokenForm.get("userRequester")?.markAsDirty();
    this.tokenForm.get("userRequester")?.markAsTouched();
    this.tokenForm.get("userRequesterDescription")?.setValue(`[${user.username}] ${user.fullname}`);
    this.tokenForm.get("userRequesterDescription")?.markAsDirty();
    this.tokenForm.get("userRequesterDescription")?.markAsTouched();
    this.tokenForm.get("email")?.setValue(user.email);
    this.tokenForm.get("email")?.markAsDirty();
    this.tokenForm.get("email")?.markAsTouched();
    this.tokenForm.get("observations")?.reset();
    this.tokenForm.get("process")?.reset();
  }


  async createToken() {
    const result = await this.confirmService.showAsync("¡Advertencia!", "¿Esta seguro de generar el token?", ModalDialogType.WARNING);
    if (result) {
      const request = new SendTokenRequest();
      request.user = this.tokenForm.getRawValue()?.userRequester;
      request.email = this.tokenForm.getRawValue()?.email;
      request.observations = this.tokenForm.getRawValue()?.observations;
      request.process = this.tokenForm.getRawValue()?.process;
      await this.tokenAuthService.generateToken(request).toPromise();
      Swal.fire({
        title: `Envio de Token`,
        text: `¡Se ha enviado un token al usuario ${this.tokenForm.getRawValue()?.userRequesterDescription}!`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
    }

  }
}
